import { Link, usePage } from "@inertiajs/react"

import { claimPath } from "@/routes"

interface SharedProps {
  organization?: {
    slug: string
    ephemeral?: boolean
    expires_at?: string | null
    onboarding_state?: string | null
  } | null
  [key: string]: unknown
}

function daysUntil(iso: string | null | undefined): number | null {
  if (!iso) return null
  const ms = new Date(iso).getTime() - Date.now()
  return Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)))
}

export default function DemoBanner() {
  const { organization } = usePage<SharedProps>().props
  if (!organization?.ephemeral) return null

  const days = daysUntil(organization.expires_at)

  return (
    <div className="bg-primary text-primary-foreground flex items-center justify-between gap-4 px-4 py-2 text-sm">
      <div>
        <strong>DEMO MODE</strong>
        {days !== null && (
          <span className="ml-2 opacity-80">expires in {days}d</span>
        )}
      </div>
      <Link
        href={claimPath(organization.slug)}
        className="rounded bg-white/10 px-3 py-1 hover:bg-white/20"
      >
        Claim this org →
      </Link>
    </div>
  )
}
